import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Card section",
  name: "cardSection",
  type: "object",
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "items",
      title: "Cards",
      type: "array",
      of: [{ type: "mosaicCard" }]
    }
  ],
  preview: {
    select: {
      title: "title",
      items: "items"
    },
    prepare({ title, items }) {
      return {
        title: multilingualStringPreview(title) || "(Card section)",
        subtitle: `${items.length} pages`
      };
    }
  }
});
